import CustomGenericTittleIconDataChip from "../../../../components/CustomGenericTittleIconDataChip";
import {
    CarTitle,
    DescriptionTittle, MarkerChip, MarkerTitle,
    ProvidersTitle,
    ServiceTitle,
    ServiceTypeChip
} from "../../../../components/buttons/IconButtons";
import CustomGenericUserChip from "../../../../components/CustomGenericUserChip";
import {EMPTY_VALUES, getDateFormat, getFullName} from "../../../../Apis/functions";
import React from "react";
import NotInformation from "../../../../components/NotInformation";
import {useTranslation} from "react-i18next";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const RenderExpandedRow = (props) => {
    const {t} = useTranslation();
    const row = props?.row ?? props;
    const modal = props?.modal ?? false;
    const details = props?.details ?? false;

    const formatName = (...parts) =>
        parts.filter(Boolean).join(' ').trim();

    const commentsData = [
        [row?.prePickupIssueAt,row?.prePickupIssueComment],
        [row?.departureAt,row?.departureComment],
        [row?.inTransitIssueAt,row?.inTransitIssueComment],
        [row?.deliveryAt, row?.deliveryComment],
        [row?.canceledAt,row?.canceledComment],
        [row?.rejectedAt, row?.rejectedComment],
    ];


    const supplier = [
        { name: getFullName(row?.supplierEmployeeName, row?.supplierEmployeeLastName, row?.supplierEmployeeSecondLastName) },
        { name: formatName(
                row?.supplierVehicleBrand,
                row?.supplierVehicleColor,
                row?.supplierVehicleModel && row?.supplierVehicleModel !== 0 ? row?.supplierVehicleModel : null,
                row?.supplierVehiclePlate,
                row?.supplierVehicleSubBrand
            )
        },
    ];
    const validSupplierList = supplier.filter(item => item?.name);
    const allCommentNull = commentsData?.every(([_, comment]) => comment == null);

    return (
        <>
            {
                <>
                    <div className={"row d-flex justify-content-between"}>
                        <div className={"flex-column"}>
                            <CustomGenericTittleIconDataChip Icon={DescriptionTittle} title={'Description'}/>
                            <p className={"mb-5 ibl-font-w-400 word-break"}>{row?.description}</p>
                        </div>

                        <div className={"col-sm-12 col-md-6 col-lg-4 col-xl-4"}>
                            { !modal &&
                                <CustomGenericTittleIconDataChip
                                    Icon={ProvidersTitle}
                                    title={"supplier"}
                                    name={row?.supplierCompanyName}
                                    key={row?.id}
                                    emptyDefaultText={"unassigned"}
                                />
                            }
                        </div>

                        <div className={"col-sm-12 col-md-6 col-lg-4 col-xl-4"}>
                            <CustomGenericTittleIconDataChip
                                Icon={ServiceTitle}
                                title={"service_type"}
                                name={row?.serviceTypeName}
                                key={row?.id}
                                IconAvatar={ServiceTypeChip}
                            />
                        </div>
                        <div className={"col-sm-12 col-md-6 col-lg-4 col-xl-4"}>
                            {(details || !modal) &&
                            <>
                                {validSupplierList?.length > 0 ?
                                    <CustomGenericUserChip
                                        Icon={CarTitle}
                                        title={"transport_operator"}
                                        list={validSupplierList}
                                        getName={item => (item?.name || EMPTY_VALUES.DEFAULT)}
                                        classNameContainerList={"row"}
                                    />

                                    :
                                    <CustomGenericTittleIconDataChip
                                        Icon={ProvidersTitle}
                                        title={"transport_operator"}
                                        emptyDefaultText={"unassigned"}
                                        key={row?.id}
                                    />
                                }
                            </>
                            }
                        </div>
                    </div>
                    <div className={"flex-column mt-5"}>
                        <CustomGenericTittleIconDataChip
                            row={(details || !modal)}
                            Icon={MarkerTitle}
                            title={'origin'}
                            name={row?.originCenterName}
                            key={row?.id} border={false}
                            IconAvatar={MarkerChip}
                        />

                        {(details || !modal) && (
                            <div className="mt-1 d-flex flex-column justify-content-space-evenly align-item-start border-left-shades-300 minh-10vh">
                                <div className={"ml-3 my-3 border-top-bottom-shades-300 minh-8vh"}>
                                    {!commentsData || allCommentNull
                                        ? (
                                            <div className="my-2">
                                                <NotInformation text={t('no_comments_yet')} card={true} />
                                            </div>
                                        )
                                        : (commentsData
                                                .filter(([_, comment]) => !!comment)
                                                .map(([at, comment], i) => (
                                            <p key={i} className="ml-4 mt-1 mb-1 mr-5 ibl-font-w-400 word-break">
                                                <strong className="font-bold">{ getDateFormat(at) }</strong>
                                                {': '}
                                                { comment }
                                            </p>
                                            ))
                                        )
                                    }

                                </div>
                            </div>
                        )}
                        <CustomGenericTittleIconDataChip
                            row={(details || !modal)} I
                            con={MarkerTitle}
                            title={'destiny'}
                            name={row?.destinationCenterName}
                            key={row?.id} border={false}
                            IconAvatar={MarkerChip}
                        />
                    </div>
                </>
            }
        </>
    );
};

export default RenderExpandedRow;
